import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskAssigneeChanged } from 'api/notifications/meta';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { Causer } from './causer';
import { UserListWithAvatar } from './user-list-with-avatar';

export const TaskAssigneeChangedView: FC<{ meta: TaskAssigneeChanged }> = ({
  meta: { by, additions, externalUser, removals },
}) => {
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);

  return (
    <FormattedMessage
      id="notifications.messages.task_assignee_changed"
      values={{
        causer: <Causer user={userDetails} />,
        action: additions == null ? 'removed' : 'added',
        assignees: <UserListWithAvatar users={additions ?? removals ?? []} />,
      }}
    />
  );
};
